module.exports = __webpack_public_path__ + "assets/calltrackingmetrics.04aa83f7.svg";